import 'slick-carousel/slick/slick';
import logger from '../utils/rbmc.logger';

const landingPageSlider = {
    landingPageSlider: $('.subshop-slider'),
    buildSlider($slider) {
        // SlickSlider can't handle only one item also return
        if ($slider.find('.subshop-slider__item').length === 1) {
            return;
        }
        $slider
                .removeClass('subshop-slider--not-ready')
                .on('init', (event, slick) => {
                    // some hack to fix the behaviour for carousels with few elements
                    if (slick.slideCount < 4) {
                        slick.originalSettings.slidesToScroll                        = slick.slideCount;
                        slick.originalSettings.slidesToShow                          = slick.slideCount;
                        slick.originalSettings.responsive[0].settings.slidesToScroll = slick.slideCount;
                        slick.originalSettings.responsive[0].settings.slidesToShow   = slick.slideCount;
                    }
                    const windowWidth = window.innerWidth || $(window).width();
                    if (windowWidth <= 1200) {

                        window.setTimeout(() => {
                            slick.options.speed          = 1500;
                            slick.options.waitForAnimate = false;
                            slick.slickNext();
                            window.setTimeout(() => {
                                slick.slickPause();
                                slick.slickPrev();
                                setTimeout(() => {
                                    slick.options.speed          = 300;
                                    slick.options.waitForAnimate = true;
                                }, 1500)
                            }, 500);
                        }, 300);
                    }
                })
                .slick({
                    arrows:         true,
                    nextArrow:      '',
                    prevArrow:      '',
                    accessibility:  true,
                    infinite:       true,
                    slidesToScroll: 1,
                    slidesToShow:   3,
                    speed:          1500,
                    dots:           false,
                    rows:           0,
                    variableWidth:  true,
                    mobileFirst:    true,
                    waitForAnimate: false,
                    swipeToSlide:   true,
                    responsive:     [
                        {
                            breakpoint: 684,
                            settings:   {
                                slidesToScroll: 1,
                                slidesToShow:   5
                            }
                        },
                        {
                            breakpoint: 1200,
                            settings:   {
                                slidesToScroll: 1,
                                slidesToShow:   7,
                                prevArrow:      $('.subshop-slider__prev')[0],
                                nextArrow:      $('.subshop-slider__next')[0],
                                waitForAnimate: false,
                                speed:          300
                            }
                        }
                    ]
                });
    },
    buildCarousels() {
        this.landingPageSlider.each((index, element) => {
            let $element = $(element);
            this.buildSlider($element);
        });
    },
    buildArcSubshopSlider() {
        landingPageSlider.buildSlider($('#hp_subshop_slider_lazyloaded .subshop-slider'));
    }
};

// DOM ready
$(() => {
    if (!(RedBull.config.archibaldRenderingEnabled && RedBull.config.archibaldCMSPlainHtmlComponentEnabled)) {
        logger.log('Fallback for subshop slider');
        landingPageSlider.buildCarousels();
    }
});

export default landingPageSlider;